export default{
  "Mute Video": "Video in Muto",
  "HitPaw Online Mute Video": "HitPaw Online Muto Video",
  "Fast and easy to remove sound from your video online": "Veloce e facile da rimuovere il suono dal tuo video online",
  "Muting": "In Muto",
  "Mute Failed": "Muto fallito",
  "Mute New": "Muto Nuovo"
};